export const selectClientInfo = (state) => state.clients.clientInfo;

export const selectRepairHistory = (state) => state.clients.carRepairHistory;

export const selectRoadmapHistory = (state) => state.clients.roadmapHistory;

export const selectRoadmapHistoryLoading = (state) =>
  state.clients.roadmapHistoryLoading;

export const selectLoading = (state) => state.clients.isLoading;

export const selectError = (state) => state.clients.error;

export const selectClientsList = (state) => state.clients.clientsList;

export const selectClientsListLoading = (state) =>
  state.clients.clientsListLoading;

export const selectCarWithoutClient = (state) =>
  state.clients.carWithoutClient;

export const selectCarWithoutClientLoading = (state) =>
  state.clients.carWithoutClientLoading;
